import {Icon, Layout, Text} from '@eitje/web_components'
import {FIRM_STATUS_ICON_MAPPING} from './firm_status_icon_mapping'

export const FirmStatusCell = ({getValue, total}) => {
	const status = getValue()
	const {color, icon} = FIRM_STATUS_ICON_MAPPING[status] || {}

	return (
		<Layout style={{display: 'inline-flex'}}>
			<Icon name={icon} fill={color} size={10} />
			<Text t={`common.status.${status}`} />
			<Text>{total}</Text>
		</Layout>
	)
}
